/**
 * Get all of an element's parent elements up the DOM tree
 * @param  {Node} elem -The element
 * @param  {String} selector - Selector to match against [optional]
 * @return {Array<Node|null>} The parent elements
 */
export default function getParents(elem: any, selector: string): Array<any> {
    // Setup parents array
    const parents = [];

    // Get matching parent elements
    for (; elem && elem !== document; elem = elem.parentNode) {

        // Add matching parents to array
        if (selector) {
            if (elem.matches(selector)) {
                parents.push(elem);
            }
        }
        else {
            parents.push(elem);
        }
    }

    return parents;
}